import { z } from 'zod';
import { CrewClaimTypeEnum } from '../../enums/crew.js';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
import { claimAddress } from './address.js';
import { claimLineItemCreate } from './claimLineItem.js';
import { customerUiEventCustomField } from './customField.js';
import { Pegasus } from './pegasus.js';
import { rate, returnShipmentMethod } from './shipmentRate.js';
export const calculatedOrderLineItem = claimLineItemCreate.extend({
    grams: z.coerce.number(),
});
export const calculatedOrder = z.object({
    id: z.number(),
    claimType: enumToZodLiteralUnion(CrewClaimTypeEnum),
    calculatedLineItems: z.array(calculatedOrderLineItem),
    returnShipment: returnShipmentMethod.nullish(),
    toCustomerRate: rate.nullish(),
});
export const calculatedOrderShipmentQuote = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
})
    .extend({
    address: claimAddress,
});
export const calculatedOrderNoResolutions = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
    calculatedLineItems: true,
})
    .extend({
    calculatedLineItems: z.array(calculatedOrderLineItem.omit({
        requestedResolutionMethodEnum: true,
    })),
});
// --------- response bodies -----------------------
export const calculatedAfterReasonSelection = z.object({
    eventPolicyEnforcement: Pegasus.eventPolicyEnforcement.nullable(),
    eventCustomFields: customerUiEventCustomField.nullable(),
});
export const calculatedIncentiveEstimate = z.object({
    giftCardIncentiveAmount: z.number().nullable(),
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sharedTotal = z.object({
    tax: z.number(),
    subtotal: z.number(),
    total: z.number(),
    shipping: z.number(),
});
const toCustomer = sharedTotal;
const fromCustomer = sharedTotal.extend({
    incentive: z.number(),
    fee: z.number(),
    feeLabel: z.string().optional(),
});
export const calculatedBeforeClaimSubmission = z.object({
    balance: z.number(),
    authorizedAmount: z.number(),
    toCustomer: toCustomer.nullable(),
    fromCustomer,
});
//# sourceMappingURL=calculatedOrder.js.map